import { Seo } from "../components/site/Seo";
import { PageHero } from "../components/site/PageHero";
import { InfoGrid } from "../components/site/Sections";
import { CtaFinal } from "../components/site/CtaFinal";

const VALUES = [
  { title: "Profissionalismo", text: "Cada pedido é tratado com rigor, desde a primeira análise até à execução da instalação." },
  { title: "Confiança", text: "Propostas claras, sem promessas de poupança que não possam ser sustentadas por dados concretos." },
  { title: "Inovação", text: "Acompanhamos a evolução das tecnologias fotovoltaicas e de armazenamento para propor soluções atuais." },
  { title: "Eficiência energética", text: "O objetivo é aproveitar melhor a energia — produzir com inteligência e consumir com critério." },
  { title: "Sustentabilidade", text: "Acreditamos que a energia solar é uma parte importante de uma utilização mais responsável dos recursos." },
  { title: "Proximidade", text: "Contacto direto por telefone, WhatsApp ou e-mail, com respostas claras às suas dúvidas." },
];

export default function SobreNosPage() {
  return (
    <>
      <Seo title="Sobre Nós | Mega Solar — Energias Renováveis" path="/sobre-nos"
        description="A Mega Solar é uma empresa de energias renováveis especializada na instalação de painéis solares fotovoltaicos para habitações e empresas em Portugal." />
      <PageHero testId="about-hero" eyebrow="Sobre nós" lines={["Energia limpa,", "pensada com rigor."]}
        text="A Mega Solar é uma empresa de energias renováveis especializada na instalação de painéis solares fotovoltaicos, com foco em clientes residenciais e empresariais em Portugal."
        image="/images/tecnico2.jpg" alt="Eletricista com capacete a instalar um sistema de painéis solares fotovoltaicos" />
      <InfoGrid testId="about-values" eyebrow="O que nos orienta" title="Os princípios do nosso trabalho." items={VALUES} />
      <section className="bg-white pb-24 sm:pb-32">
        <div className="container-x">
          <div data-testid="about-placeholder" className="rounded-[1.75rem] border-2 border-dashed border-forest/20 p-8 text-ink/75 sm:p-10">
            <p className="eyebrow text-forest/70">Conteúdo a completar</p>
            <p className="mt-3 max-w-2xl leading-relaxed">[A Mega Solar deverá indicar aqui a sua história, a equipa, as áreas de atuação e eventuais certificações — informação que não foi incluída para não apresentar dados não confirmados.]</p>
          </div>
        </div>
      </section>
      <CtaFinal />
    </>
  );
}
